import { useEffectiveUser } from "@/hooks/useEffectiveUser";
import { useLocation, useNavigate } from "react-router-dom";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function ProgressTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useEffectiveUser();

  const tabs = [
    { name: "Stats", urlPrefix: "/stats", href: "/stats" },
    {
      name: "Workout Logs",
      urlPrefix: "/workouts",
      href: user.last_trained_local_date
        ? "/workouts/date/" + user.last_trained_local_date
        : "/workouts",
    },
  ]; //last_trained_local_date

  const isActive = (urlPrefix: string) => {
    return location.pathname.startsWith(urlPrefix);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-40 bg-bg-light border-b border-bd-overlay mb-5">
      <nav aria-label="Tabs" className="-mb-px flex space-x-8 px-6">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => {
              navigate(tab.href);
            }}
            aria-current={isActive(tab.urlPrefix) ? "page" : undefined}
            className={classNames(
              isActive(tab.urlPrefix)
                ? "border-primary text-primary text-lg font-semibold "
                : "border-transparent text-tx-muted text-lg font-medium hover:border-gray-300 hover:text-gray-700",
              "border-b-3 px-1 pt-6 pb-3 whitespace-nowrap cursor-pointer"
            )}
          >
            {tab.name}
          </button>
        ))}
      </nav>
    </div>
  );
}
